// import { Icon } from "react-native-vector-icons/Icon";
import React, { useContext } from "react";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { IoMdArrowDropdown } from "react-icons/io";
import { PaystackButton } from "react-paystack";
import {
  Dots,
  Levels,
  Sentry,
  Spinner,
  Squares,
  Digital,
  Windmill,
} from "react-activity";
import "react-activity/dist/library.css";
import AuthContext from "../global/auth-context";
import {
  LoginWithGoogleService,
  LoginWithGoogleWebsiteService,
  SignupService,
} from "../models/ApiService";
import {
  GoogleLogin,
  hasGrantedAllScopesGoogle,
  useGoogleLogin,
} from "@react-oauth/google";
import { GrGooglePlus } from "react-icons/gr";
import { Link } from "react-router";
import axios from "axios";

export function SignInWithGoogle({ navigate }) {
  let { messagingToken, login } = useContext(AuthContext);
  async function LoginFunction(payload) {
    let response = await LoginWithGoogleWebsiteService(payload);
    if (response.success == true) {
      login(payload);
      ToastSuccess(response.message);
      navigate("/");
    } else {
      ToastError(response.message);
    }
  }
  const MyGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse.scope);
      // fetching userinfo can be done on the client or the server
      const userInfo = await axios
        .get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then((res) => res.data);

      let email = userInfo.email;

      LoginFunction(email);

      console.log(userInfo);
    },
  });
  return (
    <Link
      onClick={MyGoogleLogin}
      className="md:py-3 border-2 g-signin2 border-myNormalGreen self-center flex justify-center items-center gap-2 bg-white py-2 text-myNormalGreen font-bold text-lg w-full text-center rounded-xl"
    >
      <span> Google</span>
      <GrGooglePlus size={25} />
    </Link>
  );
}

export function SignUpWithGoogle({ navigate }) {
  let { messagingToken, login } = useContext(AuthContext);
  async function SignUpFunction(payload) {
    let response = await SignupService(payload);
    if (response.success == true) {
      login(payload.email);
      ToastSuccess(response.message);
      // loadProfile();
      navigate("/");
    } else {
      ToastError(response.message);
    }
  }
  const MyGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse.scope);
      // fetching userinfo can be done on the client or the server
      const userInfo = await axios
        .get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then((res) => res.data);

      let email = userInfo.email;
      let dp = userInfo.picture;
      let username =
        userInfo.name.split(" ")[0].toLowerCase() +
        Math.floor(Math.random() * 1000);

      let password =
        userInfo.name.split(" ").join("").toLowerCase() +
        Math.floor(Math.random() * 10000);

      let payload = { email, dp, username, password };

      SignUpFunction(payload);

      console.log(userInfo);
    },
  });
  return (
    <Link
      onClick={MyGoogleLogin}
      className="md:py-3 border-2 border-myNormalGreen self-center flex justify-center items-center gap-2 bg-white py-2 text-myNormalGreen font-bold text-lg w-full text-center rounded-xl"
    >
      <span> Google</span>
      <GrGooglePlus size={25} />
    </Link>
  );
}

export function Loader({ message }) {
  return (
    <div
      style={{
        height: "90vh",
      }}
      className="flex  justify-center items-center w-screen bg-mynormalGreen"
    >
      <div className="flex relative flex-col justify-center  items-center ">
        <img src="/loading.gif" alt="loading..." className="h-40" />
        <text className="absolute bottom-1 text-myNormalGreen font-medium">
          {message}
        </text>
      </div>
    </div>
  );
}

export function DropDown({ Text, TextColor, ArrowColor }) {
  return (
    <div className="flex items-center justify-between p-5 h-12 w-full">
      <SubHeading Text={Text} TextColor={TextColor} />
      <IoMdArrowDropdown color={ArrowColor} size={25} />
    </div>
  );
}

export const PayPaystack = ({ user, amount, success }) => {
  return (
    <PaystackButton
      className="bg-myNormalGreen text-white px-5 py-2 rounded-full"
      reference={new Date().getTime().toString()}
      publicKey="pk_live_634687ae6100d87f9bef36ec2c882faf12009312"
      amount={amount}
      email={user}
      currency="NGN"
      text="Pay Now"
      onClose={(e) => {
        // handle response here
        console.log(e);
        ToastError("payment failed");
      }}
      onSuccess={(res) => {
        // handle response here
        success();
      }}
      onBankTransferConfirmationPending={() => {
        success();
      }}
      channels={[
        "card",
        "bank",
        "ussd",
        "qr",
        "mobile_money",
        "bank_transfer",
        "eft",
        "apple_pay",
      ]}
    />
  );
};

export function Button({ callBack, Text, BgColor, TextColor, type }) {
  return (
    <button
      onClick={callBack}
      style={{
        backgroundColor: BgColor,
        color: TextColor,
        // padding: 10,
        borderRadius: 100,
        border: "none",
        fontSize: 16,
        fontWeight: 500,
        width: "100%",
      }}
      className="px-5 py-2"
      type={type}
    >
      {Text}
    </button>
  );
}

export function LongButton({ type, callBack, Text }) {
  return (
    <button
      onClick={callBack}
      style={{
        backgroundColor: type === "default" ? "#C36329" : "red",
        color: "white",
        borderRadius: 10,
        paddingInline: 20,
        border: "none",
        fontSize: 16,
      }}
    >
      {Text}
    </button>
  );
}

export function Input({ placeholder, value, onchange, borderColor, type }) {
  return (
    <input
      style={{
        borderRadius: 25,
        width: "100%",
        borderColor: borderColor,
        borderWidth: 2,
        height: 50,
        outline: "#016401",
      }}
      className="flex px-5"
      value={value}
      onChange={(e) => {
        onchange(e.target.value);
        // console.log(e.target.value);
      }}
      placeholder={placeholder}
      type={type}
    />
  );
}

export function SingleInput({ placeholder, value, onchange }) {
  return (
    <input
      style={{
        borderRadius: 5,
        width: 20,
        height: 20,
        borderColor: "lightgrey",
        borderWidth: 1.5,
        paddingInline: 10,
      }}
      value={value}
      onChange={(e) => {
        onchange(e.target.value);
        // console.log(e.target.value);
      }}
      placeholder={placeholder}
    />
  );
}

export function BoldHeading({ Text, Width, TextColor }) {
  return (
    <div
      style={{
        width: `${Width}vw`,
      }}
    >
      <text
        style={{
          fontSize: 50,
          fontWeight: "700",
          color: `${TextColor}`,
        }}
      >
        {Text}
      </text>
    </div>
  );
}

export function NormalHeading({ Text, Width, TextColor }) {
  return (
    <div
      style={{
        width: `${Width}vw`,
      }}
    >
      <text
        style={{
          fontSize: 20,
          fontWeight: "500",
          color: `${TextColor}`,
        }}
      >
        {Text}
      </text>
    </div>
  );
}

export function SubHeading({ Text, Width, TextColor }) {
  return (
    <div
      style={{
        width: `${Width}vw`,
      }}
    >
      <text
        style={{
          fontSize: 15,
          fontWeight: "500",
          color: `${TextColor}`,
        }}
      >
        {Text}
      </text>
    </div>
  );
}

export function BodyText({ Text, Width, TextColor }) {
  return (
    <div
      style={{
        width: `${Width}%`,
      }}
    >
      <text
        style={{
          fontSize: 15,
          fontWeight: "400",
          color: `${TextColor}`,
        }}
      >
        {Text}
      </text>
    </div>
  );
}

export function SmallText({ Text, Width, TextColor }) {
  return (
    <div
      style={{
        width: `${Width}%`,
      }}
    >
      <text
        style={{
          fontSize: 12,
          fontWeight: "400",
          color: `${TextColor}`,
        }}
      >
        {Text}
      </text>
    </div>
  );
}

export const ToastSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
  });
  <ToastContainer />;
};

export const ToastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
  });
  <ToastContainer />;
};
